module.exports = __webpack_public_path__ + "static/media/img3-360-360.0abefe68.webp";